import script from "./PasswordEditPage.vue?vue&type=script&setup=true&lang=js"
export * from "./PasswordEditPage.vue?vue&type=script&setup=true&lang=js"

import "./PasswordEditPage.vue?vue&type=style&index=0&id=620c8ba1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-620c8ba1"]])

export default __exports__